var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/async-validator/~/core-js/library/modules/_html.js
// module id = 331
// module chunks = 0